import { useQuery } from "@tanstack/react-query";
import { fetchBranches } from "../api/fetch-branches";

export const BRANCHES_QUERY_KEY = "branches";

export function useBranches() {
  return useQuery({
    queryKey: [BRANCHES_QUERY_KEY],
    queryFn: fetchBranches,
  });
}
